import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Partner } from 'model/Partner';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import Modal, { modalStyle } from 'component/part/Modal';
import H2 from 'component/part/H2';

const PartnerShow: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const partnerId = parseInt(urlParams.id || '');
  const [partner, setPartner] = useState<Partner>();
  const [confirm, setConfirm] = useState(false);
  const [resultStatus, setResultStatus] = useState(0);

  const onSubmit = async () => {
    if (partner) {
      const result = await api.partner.delete(partner.id);
      setConfirm(false);
      setResultStatus(result ? 1 : 2);
    }
  };

  const onUnderstoodResult = () => {
    setResultStatus(0);
    if (resultStatus === 1) {
      navigate('/partner/list');
    }
  };

  useEffect(() => {
    (async () => {
      if (partnerId) {
        const partnerResponse = await api.partner.get(partnerId);
        if (partnerResponse) {
          setPartner(partnerResponse);
        }
      }
    })();
  }, [partnerId]);

  return <Layout>
    <BackLink link='/partner/list' label='協力業者一覧'></BackLink>
    <H2>業者情報</H2>
    <div css={generalStyle.form}>
      <FormContent label='業者名'>
        <div css={generalStyle.item()}>{partner?.name || ''}</div>
      </FormContent>
      <FormContent label='日給'>
        <div css={generalStyle.item()}>{partner?.unitSalary ? `\xA5${partner.unitSalary.toLocaleString()}` : 'ー'}</div>
      </FormContent>
      {partner && (
        <div css={generalStyle.formRow}>
          <NavLink to={`/partner/${partner.id}/edit`} css={generalStyle.button()}>編集</NavLink>
          <button onClick={() => setConfirm(true)} css={generalStyle.button('warning')}>削除</button>
        </div>
      )}
    </div>
    <Modal display={confirm} onHide={() => setConfirm(false)}>
      <div>この協力業者を削除します</div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onSubmit} css={generalStyle.button()}>確定</button>
        <button onClick={() => setConfirm(false)} css={generalStyle.button('warning')}>キャンセル</button>
      </div>
    </Modal>
    <Modal display={!!resultStatus} onHide={onUnderstoodResult}>
      <div>
        {resultStatus === 1 ? '削除が完了しました' : '削除に失敗しました'}
      </div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onUnderstoodResult} css={generalStyle.button()}>OK</button>
      </div>
    </Modal>
  </Layout>;
};

export default PartnerShow;
